// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface IndentLeftIconSignature {
  Element: SVGSVGElement;
}

export const IndentLeftIcon: TOC<IndentLeftIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 2H13V22H11V2ZM5.293 9.708L6.586 11H2V13H6.586L5.293 14.294L6.707 15.708L10.414 12L6.707 8.294L5.293 9.708ZM22 3H14V5H22V3ZM14 7H20V9H14V7ZM22 11H14V13H22V11ZM14 15H20V17H14V15ZM22 19H14V21H22V19Z"/>
</svg>
</template>;